import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 22,
  medium: 18,
  small: 12,
  xSmall: 9
};
const PlayIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  const renderIcon = () => {
    switch (size) {
      case "small":
      case "xSmall":
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 20 20",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M4 3L16 10.0004L4 17V3ZM5 4.74001V15.259L14.015 10L5 4.74001Z",
              fill: "currentColor"
            }
          )
        );
      case "medium":
      case "large":
      default:
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 30 30",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M6.5 5V24.7098L24.0199 14.8549L6.5 5ZM7.5 6.70992L21.98 14.8549L7.5 22.9989V6.70992Z",
              fill: "currentColor"
            }
          )
        );
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, renderIcon());
};
PlayIcon.iconName = "PlayIcon";

export { PlayIcon };
